/* Disable no color literals as we're dealing with shadows which have no formal location yet */
/* eslint-disable medely/noColorLiterals */
import type { CardElevation } from './interface';

export const SHADOW_MAP: Record<CardElevation, string> = {
  // TODO FET-46: Mobile shadow support for L-1
  // '-1': '0.5px 0.5px 1px 0px #00000040 inset',
  '1': '0.5px 0.5px 1.5px 0px #73808C9E',
  '2': '0.5px 0.5px 2px 0px #73808C33, 2px 4px 6px 0px #73808C2B, 3px 6px 16px 0px #73808C1F',
  '3': '0.5px 0.5px 1.5px 0px #73808C1F, 2px 4px 4px 0px #73808C1F, 3px 6px 12px 0px #73808C1F, 8px 16px 24px 0px #73808C1F, 12px 20px 28px 0px #73808C1A',
  '4': '1px 2px 2px 0px #73808C29, 2px 4px 4px 0px #73808C29, 4px 8px 8px 0px #73808C29, 8px 16px 16px 0px #73808C29, 16px 32px 40px 0px #73808C29, 20px 32px 40px 0px #73808C1A',
};
